/* eslint-disable no-undef */
// export default {
//   calendatSize: process.env.REACT_APP_CALENDAR_SIZE || 10,
//   weekDaysList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
//   monthList: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//   timeZone: 'Asia/Kolkata',
//   dateFormate: 'MM/dd/yyyy',
//   serverUrl: process.env.REACT_APP_SERVER_URL,
//   SSO_AUTH_URL: process.env.REACT_APP_SSO_AUTH_URL,
//   SSO_USER_ENCYPTER: process.env.REACT_APP_SSO_USER_ENCYPTER ,
//   REDIRECT_URL: process.env.REACT_APP_REDIRECT_URL,
//   ENCRYPTOR_KEY: process.env.REACT_APP_ENCRYPTOR_KEY,
//   APP_KEY: process.env.REACT_APP_APP_KEY,
//   ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY,
//   dataIVKey: process.env.REACT_APP_DATA_IV_KEY
// };


export default {
  calendatSize: 10,
  weekDaysList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  monthList: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  timeZone: 'Asia/Kolkata',
  dateFormate: 'MM/dd/yyyy',
  serverUrl: 'https://redcm-upgrade.reddoorz.in/app/',
  SSO_AUTH_URL: "https://redoauth.reddoorz.in/",
  SSO_USER_ENCYPTER: '3712d7z97sd6727b3e6a6a56c8662841',
  REDIRECT_URL: 'https://redcm-upgrade.reddoorz.in',
  ENCRYPTOR_KEY: 'cm_backend',
  APP_KEY: "cm_backend",
  ENCRYPTION_KEY: '5mwHvNTqCAn2T8wfxAIljCBbJ5+G+YFe',
  dataIVKey: 'cm_backend'
};